import { render, staticRenderFns } from "./ChangeLangaugeDropdown.vue?vue&type=template&id=48805eb8&"
import script from "./ChangeLangaugeDropdown.vue?vue&type=script&lang=js&"
export * from "./ChangeLangaugeDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLangaugeDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports